<!--<mat-card>-->
<!--  <mat-card-content>-->
<form
  *ngIf="showFilterForm"
  class="tw-flex tw-w-full tw-pt-4"
  [formGroup]="formSearch"
>
  <mat-form-field appearance="outline" class="tw-w-full">
    <mat-label>{{ titleOfFilter }}</mat-label>
    <input matInput type="text" name="search" formControlName="search" />
  </mat-form-field>
</form>

<div class="title-of-list" [ngClass]="classTitleOfList" *ngIf="titleOfList">
  {{ titleOfList }}
</div>

<ng-container
  [ngTemplateOutlet]="templateMainContent"
  [ngTemplateOutletContext]="{
    filteredList: filteredList$ | async,
    list: list$ | async,
    disableMovement: disableMovement$ | async
  }"
>
</ng-container>
<!--  </mat-card-content>-->
<!--</mat-card>-->

<ng-template
  #templateMainContent
  let-filteredList="filteredList"
  let-list="list"
  let-disableMovement="disableMovement"
>
  <div
    appSchedulerListDirective
    [orientation]="selectedOrientation"
    [listSize]="list.length"
    cdkDropList
    [cdkDropListOrientation]="selectedOrientation"
    [cdkDropListData]="list"
    (cdkDropListDropped)="drop($event)"
    [id]="idList"
    [class.read-viewer]="disableMovement"
  >
    <div
      *ngFor="let item of filteredList"
      class="tw-flex tw-p-0 tw-m-0"
      [class.tw-w-full]="selectedOrientation === 'vertical'"
      cdkDrag
      [cdkDragData]="item"
      [cdkDragStartDelay]="viewForTablet ? 350 : 0"
      [id]="'list-' + item.id + '-' + idList"
      [cdkDragDisabled]="disableMovement"
      #itemContainer
    >
      <div
        class="placeholder"
        *cdkDragPlaceholder
        [ngStyle]="setMinWidth(itemContainer)"
      ></div>
      <ng-container
        [ngTemplateOutlet]="templateItem"
        [ngTemplateOutletContext]="{
          item: item
        }"
      ></ng-container>
    </div>
  </div>
  <ng-container
    *ngIf="showEmptyTitles"
    [ngTemplateOutlet]="templateShowEmptyTitles"
    [ngTemplateOutletContext]="{
      filteredListLength: filteredList.length,
      listLength: list.length
    }"
  ></ng-container>
</ng-template>

<ng-template
  #templateShowEmptyTitles
  let-filteredListLength="filteredListLength"
  let-listLength="listLength"
>
  <div
    *ngIf="filteredListLength === 0 && listLength > 0"
    class="no-items-on-list"
  >
    <h2>{{ "COMMON.SEARCH_EMPTY_LIST" | translate }}</h2>
  </div>
  <div *ngIf="listLength === 0" class="no-items-on-list">
    <h2>{{ "COMMON.EMPTY_LIST" | translate }}</h2>
  </div>
</ng-template>
